// toasts.js — global toast notification utility.
//
// Dispatch the custom `app:toast` event from anywhere in the app to show a toast:
//
//   document.dispatchEvent(new CustomEvent('app:toast', {
//     detail: {
//       message: 'Operation complete.',  // required — text shown in the toast body
//       type:    'success',              // optional — controls header color and icon (default: 'info')
//       delay:   5000,                  // optional — ms before auto-dismiss (default: 5000)
//     }
//   }))
//
// Supported types and their appearance:
//
//   Type        Header color   Icon
//   ----------  -------------  --------------------------
//   info        blue           bi-info-square-fill
//   success     green          bi-check-square-fill
//   warning     yellow         bi-exclamation-square-fill
//   danger      red            bi-x-square-fill
//   primary     Bootstrap      bi-square-fill
//   secondary   Bootstrap      bi-square-fill
//
// Unknown types fall back to 'info'.
//
// The toast container must exist in the DOM with id="toast-container".
// It is rendered in app/views/layouts/application.html.erb.

import * as bootstrap from "bootstrap"

const TYPE_CONFIG = {
  info:      { icon: "bi-info-square-fill",          label: "Info"    },
  success:   { icon: "bi-check-square-fill",         label: "Success" },
  warning:   { icon: "bi-exclamation-square-fill",   label: "Warning" },
  danger:    { icon: "bi-x-square-fill",             label: "Danger"  },
  primary:   { icon: "bi-square-fill",               label: "Notice"  },
  secondary: { icon: "bi-square-fill",               label: "Notice"  },
};

function show_toast({ message, type = "info", delay = 5000 }) {
  const container = document.getElementById("toast-container");
  if (!container) return;

  const config = TYPE_CONFIG[type] ?? TYPE_CONFIG["info"];

  const el = document.createElement("div");
  el.className = "toast border-0";
  el.setAttribute("role", "alert");
  el.setAttribute("aria-live", "assertive");
  el.setAttribute("aria-atomic", "true");
  el.innerHTML = `
    <div class="toast-header">
      <i class="bi ${config.icon} text-${type} me-2"></i>
      <strong class="me-auto">${config.label}</strong>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">${message}</div>`;

  container.appendChild(el);
  const toast = new bootstrap.Toast(el, { delay });
  el.addEventListener("hidden.bs.toast", () => el.remove());
  toast.show();
}

export function init_toasts() {
  document.addEventListener("app:toast", (event) => {
    show_toast(event.detail ?? {});
  });
}
